// Keep sync with `ryde-backend/libs/shared/src/enums/recaptcha-enterprise-actions.ts`
// Different actions on server and client - lead to error.
export enum RecaptchaEnterpriseActions {
  LOGIN = "LOGIN",
  RESET_PASSWORD = "RESET_PASSWORD",
  CHECK_IF_USER_EXISTS = "CHECK_IF_USER_EXISTS",
  REQUEST_OTP = "REQUEST_OTP",
  MFA_VERIFY = "MFA_VERIFY",
  MFA_RESEND = "MFA_RESEND",
}
